export function initBackToTop() {
    const btn = document.querySelector("#backToTop");
    if (!btn) return;

    btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });

    let scrollTicking = false;
    window.addEventListener("scroll", () => {
        if (!scrollTicking) {
            requestAnimationFrame(() => {
                btn.style.opacity = window.scrollY > 300 ? "1" : "0.6";
                scrollTicking = false;
            });
            scrollTicking = true;
        }
    }, { passive: true });
}
